<template>
  <!-- 静态本地 SVG，非用户输入 -->
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span class="app-icon" aria-hidden="true" v-html="svg" />
</template>

<script setup lang="ts">
import { appIcons, type AppIconName } from '~/assets/icons'

const props = defineProps<{
  name: AppIconName
}>()

const svg = computed(() => appIcons[props.name])
</script>

<style scoped>
.app-icon {
  display: inline-flex;
  line-height: 0;
}

.app-icon :deep(svg) {
  width: 1em;
  height: 1em;
  display: block;
}
</style>
